import { useRef, type ReactNode } from "react";
import {
  AriaDialogProps,
  AriaPopoverProps,
  Overlay,
  useDialog,
  usePopover,
} from "react-aria";
import { OverlayTriggerState } from "react-stately";
import { styled } from "styled-components";

interface PopoverProps extends Omit<
  AriaPopoverProps & AriaDialogProps,
  "popoverRef"
> {
  children: ReactNode;
  state: OverlayTriggerState;
}

interface DialogProps extends AriaDialogProps {
  title?: ReactNode;
  children: ReactNode;
}

export const PickerPopover = ({ children, state, ...props }: PopoverProps) => {
  const popoverRef = useRef(null);
  const { popoverProps, underlayProps } = usePopover(
    {
      ...props,
      popoverRef,
    },
    state,
  );

  return (
    <Overlay>
      <div {...underlayProps} style={{ position: "fixed", inset: 0 }} />
      <StyledPopover {...popoverProps} ref={popoverRef}>
        <Dialog {...props}>{children}</Dialog>
      </StyledPopover>
    </Overlay>
  );
};

const Dialog = ({ children, ...props }: DialogProps) => {
  const ref = useRef(null);
  const { dialogProps } = useDialog(props, ref);

  return (
    <DialogContainer {...dialogProps} ref={ref}>
      {children}
    </DialogContainer>
  );
};

const StyledPopover = styled.div`
  background-color: ${({ theme }) => theme.COLORS.WHITE};
  box-shadow: 1px 2px 5px 0 rgba(0, 0, 0, 0.16);
  overflow-y: auto;
`;

const DialogContainer = styled.div`
  padding: ${({ theme }) => theme.PADDING.MD};
`;
